<script lang="ts">
	import { get } from 'svelte/store';
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { devices } from 'src/stores/lists/devices';
	import { postReq } from 'src/services/http';
	import { digitalInputStatuses, getDigitalInputIcons } from 'src/helpers/addons/addon_helpers';
	//Design system components
	import { Select } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { DigitalInputStatus, Peripheral } from 'src/types/Peripherals';

	let className = '';
	export { className as class };

	export let device: Device, peripheral: Peripheral;

	export const save = async () => {
		const digitalIconParams = getDigitalInputIcons(device, component);
		const inputIconID = digitalIconParams[component];
		if (inputStatus.value === inputIconID) {
			return { isok: true };
		}
		const params: Record<string, number> = {
			...digitalIconParams,
			[`${component}`]: Number(inputStatus.value ?? 0) ?? 0,
		};
		const res = await postReq(`/interface/device/bulk_update`, {
			devices_data: `{"${id}":{"input_icons":${JSON.stringify(params)}}}`,
		});
		if (res?.isok) {
			const dev = get(devices)[id];
			dev.input_icons = params;
			devices.update(dev);
		}
		return res;
	};

	const id = real_id(device.id);
	const component = `input:${peripheral.sensor.extid}`;
	const digitalIconParams = getDigitalInputIcons(device, component);
	const inputIconID = digitalIconParams[component] ?? 0;
	const inputStatuses: DigitalInputStatus[] = digitalInputStatuses();
	let inputStatus: DigitalInputStatus = inputStatuses[inputIconID];
</script>

<Select
	size="m"
	class={className}
	id="select-digital-input-icon"
	aria-label={$format('select_digital_input_icon', {
		default: 'Select digital input icon',
	})}
	icon={inputStatus.icon}
	options={inputStatuses}
	bind:value={inputStatus}
/>
